import { createAction, props } from '@ngrx/store';

import { GeozonesGroupItem, GeozonesGroupsList } from '@services/geozones.service';

export const loadGeozonesGroups = createAction('[Geozones Groups] Load Geozones Groups');

export const loadGeozonesGroupsSuccess = createAction(
  '[Geozones Groups] Load Geozones Groups Success',
  props<{
    list: GeozonesGroupsList;
  }>(),
);

export const loadGeozonesGroupsFailure = createAction(
  '[Geozones Groups] Load Geozones Groups Failure',
  props<{
    error: string;
  }>(),
);

export const addGeozonesGroup = createAction(
  '[Geozones Groups] Add Geozones Group',
  props<{
    item: GeozonesGroupItem;
  }>(),
);
export const updateGeozonesGroup = createAction(
  '[Geozones Groups] Update Geozones Group',
  props<{
    id: number;
    changes: Partial<GeozonesGroupItem>;
  }>(),
);
export const deleteGeozonesGroup = createAction(
  '[Geozones Groups] Delete Geozones Group',
  props<{
    id: string;
  }>(),
);
